import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

const tabStyle = makeStyles(() => ({
  tabs: {
    "& .MuiTab-root": {
      fontFamily: "var(--font-family-diodrum)",
      color: "var(--color-primary-black)",
      fontSize: "var(--size-16px)",
      padding: "12px 0px",
      minWidth: "fit-content",
      marginRight: 15,
      lineHeight: 1,
      opacity: 1,
      cursor: "pointer"
    },
    "& .MuiTab-wrapper": {
      textTransform: "none"
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent"
    },
    "& .Mui-selected": {
      color: "var(--color-primary)",
      fontFamily: "var(--font-family-diodrum_semi-bold)",
      fontSize: "var(--size-24px)"
    },
    "& .Mui-selected .tab__title": {
      borderBottom: "4px solid var(--color-primary)"
    }
  },
  badgeContainer: {
    display: "flex",
    alignItems: "center",
    "& label": {
      cursor: "pointer"
    }
  },
  badge: {
    fontSize: "var(--size-16px)",
    fontFamily: "var(--font-family-diodrum_semi-bold)",
    backgroundColor: "var(--color-pale-teal)",
    color: "var(--color-primary)",
    padding: "4px 10px 2px 10px",
    marginLeft: 5,
    borderRadius: 2,
    marginBottom: 15
  }
}));

const CustomTabs = ({ tabOptions, value, tabChangeHandler }) => {
  const classes = tabStyle(this);

  const handleChange = (event, newValue) => tabChangeHandler(newValue);

  return (
    <>
      <Tabs className={classes.tabs} value={value} onChange={handleChange}>
        {tabOptions.map((tabVal, index) => (
          <Tab
            key={index}
            value={index}
            label={
              <div className={classes.badgeContainer}>
                <label className="tab__title">{tabVal.tabval}</label>
                {tabVal.count?.toString() && <span className={classes.badge}>{tabVal.count}</span>}
              </div>
            }
          />
        ))}
      </Tabs>
    </>
  );
};

export default CustomTabs;
